import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_193_vendor_bill_allocations_add: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Vendor bill wise allocation",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "vendor_bill_allocations",
        TableName: "vendor_bill_allocations",
        Plugins: [{ type: "api", module: "all" }],
        columnNumber: "m1 t1 w1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        Fields: [
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Vendor bill wise allocation details",
            BindValue: "con_vendor_bill_allocation_details",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_vendor",
                label: "Vendor name",
                placeholder: "Select vendor",
                required: true,
                lookupName: "supplier_with_due_from_transaction",
                options: [],
                Json_Attribute: "vendor_id",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Vendor name is required",
                  },
                ],
              },
            ],
          },
          {
            componentType: ComponentType.SUB_MODULE,
            name: "vendor_bill_allocations_unregistered",
            label: "Unregistered payment details",
            tableName: "vendor_bill_allocations_unregistered_split",
            lookupName: "vendor_unregistered_payments",
            parentField: "drp_vendor",
            DisableAddNewRow: true,
            enableDeleteAction: false,
            enableSearch: true,
            BindValue: "vendor_bill_allocations_unregistered_split",
            childControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_reciept_no",
                label: "Payment No.",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "reciept_no",
                disabled: true,
                BindValue: "txt_reciept_no",
              },
              {
                componentType: ComponentType.DATE_FIELD,
                name: "txt_receipt_date",
                label: "Payment date",
                placeholder: "",
                required: false,
                Json_Attribute: "receipt_date",
                disabled: true,
                BindValue: "txt_receipt_date",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_receipt_amount",
                label: "Payment amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "receipt_amount",
                defaultValue: "0",
                disabled: true,
                BindValue: "txt_receipt_amount",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_unregistered_amount",
                label: "Unregistered amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "unregistered_amount",
                defaultValue: "0",
                disabled: true,
                BindValue: "txt_unregistered_amount",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_remarks",
                label: "Details",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "remarks",
                disabled: true,
                BindValue: "txt_remarks",
              },
            ],
          },
          {
            componentType: ComponentType.SUB_MODULE,
            name: "vendor_bill_allocations_purchase",
            label: "Purchase details",
            vendorBillAllocationMode: true,
            tableName: "vendor_bill_allocations_purchase_split",
            lookupName: "vendor_purchase_details",
            parentField: "drp_vendor",
            DisableAddNewRow: true,
            enableDeleteAction: false,
            enableSearch: true,
            BindValue: "vendor_bill_allocations_purchase_split",
            childControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_purchase_no",
                label: "Purchase No.",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "purchase_no",
                disabled: true,
                BindValue: "txt_purchase_no",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_due_amount",
                label: "Due amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "due_amount",
                defaultValue: "0",
                disabled: true,
                BindValue: "txt_due_amount",
              },
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_unregistered_payment",
                label: "Payment voucher",
                placeholder: "Select unregistered payment",
                required: false,
                lookupName: "vendor_unregistered_payments",
                parentField: "drp_vendor",
                options: [],
                Json_Attribute: "ledger_unregistered_id",
                BindValue: "drp_unregistered_payment",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_max_allocate",
                label: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                disabled: true,
                IsHidden: true,
                showInSummary: false,
                style: { display: "none" },
                BindValue: "txt_max_allocate",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_amount",
                label: "Allocate amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "amount",
                defaultValue: "0",
                BindValue: "txt_amount",
                validation: [
                  {
                    rule: ValidationRule.CONDITION,
                    condition: "[txt_amount] <= [txt_due_amount]",
                    message: "Allocate amount cannot be greater than due amount",
                  },
                  {
                    rule: ValidationRule.CONDITION,
                    condition: "[txt_amount] <= [txt_max_allocate]",
                    message:
                      "Allocate amount cannot exceed the lower of due amount and unregistered payment balance",
                  },
                ],
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_due_after_allocation",
                label: "Due after allocation",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "due_after_allocation",
                defaultValue: "0",
                disabled: true,
                BindValue: "txt_due_after_allocation",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_remaining_unregistered",
                label: "Unregistered balance",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "remaining_unregistered",
                defaultValue: "0",
                disabled: true,
                BindValue: "txt_remaining_unregistered",
              },
            ],
            FooterControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_5",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_9",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_6",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_7",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_8",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                IncludeLabel: false,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_net_amount",
                Json_Attribute: "net_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_amount]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
                validation: [
                  {
                    rule: ValidationRule.CONDITION,
                    condition: "[net_amount] > 0",
                    message: "Amount must be greater than zero",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Submit",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
        },
      },
    ],
  },
];
